import { jwtDecode } from 'jwt-decode';

export const decodeIdToken = (idToken: string): { isSuperUser: boolean; shortcutSchema: string | undefined } => {
  if (!idToken) {
    return { isSuperUser: false, shortcutSchema: undefined };
  }
  let decoded: Record<string, string>;
  try {
    decoded = jwtDecode(idToken);
  } catch {
    return { isSuperUser: false, shortcutSchema: undefined };
  }
  const isSuperUser = decoded['custom:superuser']?.toLocaleLowerCase() === 'true';

  const raw = localStorage.getItem('redirectQueryParams');
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as { schema?: unknown };
      if (typeof parsed.schema === 'string' && parsed.schema.length > 0) {
        return { isSuperUser, shortcutSchema: parsed.schema };
      }
    } catch {
      // ignore malformed redirect params
    }
  }

  const tokenSchemas = decoded['custom:schema']?.split(',').filter(Boolean) ?? [];
  if (!isSuperUser && tokenSchemas.length === 1) {
    return { isSuperUser, shortcutSchema: tokenSchemas[0] };
  }

  return { isSuperUser, shortcutSchema: undefined };
};
